        // Обработка формы контактов
        document.getElementById('contactForm').addEventListener('submit', async function(e) {
            e.preventDefault();
            
            const form = e.target;
            const submitBtn = document.getElementById('submitBtn');
            const formMessage = document.getElementById('formMessage');
            
            // Получаем данные формы
            const formData = new FormData(form);
            const contact = formData.get('contact');
            const message = formData.get('message');
            
            // Проверяем валидность
            if (!contact.trim() || !message.trim()) {
                showAlert('Пожалуйста, заполните все поля', 'danger');
                return;
            }
            
            // Блокируем кнопку и показываем загрузку
            submitBtn.disabled = true;
            submitBtn.textContent = 'Отправка...';
            formMessage.style.display = 'none';
            
            try {
                const response = await fetch('/send_message', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ contact, message })
                });
                
                const result = await response.json();
                
                if (result.success) {
                    showAlert(result.message);
                    form.reset(); // Очищаем форму
                } else {
                    showAlert(result.error || 'Произошла ошибка при отправке', 'danger');
                }
            } catch (error) {
                console.error('Ошибка отправки:', error);
                showAlert('Произошла ошибка при отправке сообщения', 'danger');
            } finally {
                // Восстанавливаем кнопку
                submitBtn.disabled = false;
                submitBtn.textContent = 'Отправить вопрос';
            }
        });
        
